/**
 *
 * 新埋点
 * 制定埋：
 * v-stat="'对象‘"
 * v-stat[show|click] = object || {
 *  object, event, ...other
 * }
 * 主动埋：
 * this.eventStat(object || {
 *  object, event, ...other
 * })
 */

import 'mutationobserver-shim'
import Stat from '../lib/stat/Stat'
import { getPlatform } from '../tools/getPlatform'

const upLoadQuery = [
  'channelId',
  'channel_id',
  'cid',
  'channelFlag',
  'channel_flag',
  'source',
  'ref',
  'from'
]

const actionType = {
  click: '点击',
  show: '显示'
}

// 筛选掉有需要上传的东西
const filterQuery = query => {
  const _query = {}
  for (let i = 0; i < upLoadQuery.length; i++) {
    if (query[upLoadQuery[i]]) {
      _query[upLoadQuery[i]] = query[upLoadQuery[i]]
    }
  }
  return _query
}

const mixin = {
  mounted() {
    // 除了node其他项目没有统一的加载结束的入口，所以不自动埋，需要手动调
    // 你也可以定义个fetchPromise 😊
    // 是页面组件
    const isPageComponent =
      this.fetchPromise && typeof this.fetchPromise.then === 'function'
    // console.log(`isPageComponentisPageComponent`, isPageComponent)
    if (!this.$route) return
    const { meta } = this.$route
    if (!meta) return
    // 路由定义有meta.bussiness
    const businessInRouteMeta = meta && meta.business
    if (isPageComponent && businessInRouteMeta) {
      this.fetchPromise.then(() => {
        this.pageStat()
      })
    }
    this._statPluginPageEntryTime = new Date().getTime()
  },
  // 统计离开，不准确
  // destroyed() {
  //   if (!this.$route) return
  //   const { meta } = this.$route
  //   if (!meta) return
  //   // 路由定义有meta.bussiness
  //   const businessInRouteMeta = meta && meta.business
  //   if (!businessInRouteMeta) return
  //   const ts = new Date().getTime() - this._statPluginPageEntryTime
  //   const durationSecond = (ts / 1000 / 60) | 0
  //   let text
  //   if (durationSecond < 30) {
  //     text = '小于30s'
  //   } else if (durationSecond < 60) {
  //     text = '30s-1min'
  //   } else if (durationSecond < 180) {
  //     text = '1min-3min'
  //   } else {
  //     text = '大于3min'
  //   }

  //   this.eventStat({
  //     object: '页面离开',
  //     浏览时间: text
  //   })
  // },
  computed: {
    pageStatProperties() {
      return {}
    },
    statMixinPlatform() {
      return this.$platform || this.platform || getPlatform()
    }
  },
  methods: {
    pageStat(properties = this.pageStatProperties) {
      const { meta, query } = this.$route
      const { yixinliAPPVersion } = this.statMixinPlatform
      let title = document.title

      // for node-website
      if (
        this.$store &&
        this.$store.state &&
        this.$store.state.meta &&
        this.$store.state.meta.title
      ) {
        title = this.$store.state.meta.title
      }

      this.$stat.send({
        name: `${meta.business}-页面访问`,
        properties: {
          href: window.location.href,
          UA: window.navigator.userAgent,
          页面title: title,
          title: meta.pageName || title || '',
          App版本: yixinliAPPVersion || '',
          ...filterQuery(query),
          ...properties
        }
      })
    },
    eventStat(value = '') {
      const { business, pageName } = this.$route.meta
      // 没定义就不继续了
      if (!business) {
        throw Error('路由定义meta.business, pageName')
      }

      // 处理成对象
      if (typeof value !== 'object') {
        value = {
          object: value
        }
      }

      //处理行为
      value.event =
        actionType[value.event || (event && event.type)] ||
        value.event ||
        '点击'
      const { object, event: _event, ...otherValue } = value
      const text =
        event && event.target && event.target.innerText
          ? event.target.innerText.replace(/[ ]/g, '')
          : ''
      this.$stat.send({
        name: `${business}-交互行为`,
        properties: {
          行为: _event,
          对象: pageName ? `${pageName}-${object}` : object,
          被点击元素的文字: text,
          ...otherValue
        }
      })
    }
  }
}

// 判断dom是不是隐藏的，针对v-show
const isDomHidden = el => el.style.display === 'none'

const handleShowStat = (el, statFn) => {
  // 延迟100ms是因为立即取dom style.display取不到
  setTimeout(() => {
    const isHidden = isDomHidden(el)
    // 如果隐藏就监听着v-show
    if (isHidden) {
      el.observer = new MutationObserver(mutations => {
        // 之前是隐藏的，这次监听到变化是显示的
        if (
          mutations[0].oldValue &&
          mutations[0].oldValue.indexOf('display: none') > -1 &&
          !mutations[0].target.style.display !== 'none'
        ) {
          statFn()
        }
      })
      const options = {
        attributes: true,
        attributeOldValue: true,
        attributeFilter: ['style']
      }
      el.observer.observe(el, options)
    } else {
      // 否则直接埋v-if
      statFn()
    }
  }, 100)
}

const getVstat = () => ({
  bind(el, binding, vnode) {
    const { eventStat } = vnode.context
    let { modifiers } = binding
    // 如果没有修饰符，就当作是click
    if (Object.keys(modifiers).length === 0) {
      modifiers.click = true
    }

    const statData = () => {
      let value = binding.value
      // 处理value成对象
      if (typeof binding.value === 'string') {
        value = {
          object: binding.value
        }
      }
      return {
        被点击元素的文字: el.innerText.replace(/[ ]/g, ''),
        ...value
      }
    }

    Object.keys(modifiers).forEach(key => {
      if (key === 'show') {
        handleShowStat(el, () => eventStat(statData()))
      } else {
        el.addEventListener(key, () => eventStat(statData()))
      }
    })
  },
  unbind(el) {
    // 处理MutationObserver副作用
    if (el.observer) {
      el.observer.disconnect()
    }
  }
})

export default {
  install(Vue, options) {
    let statOptions =
      options && options.statOptions ? options.statOptions : undefined
    const stat = new Stat(statOptions)
    Vue.prototype.$stat = stat
    if (!window.yxl) {
      window.yxl = {}
    }
    window.yxl.stat = stat
    Vue.mixin(mixin)
    Vue.directive('stat', getVstat())
    // 标记诸葛用户 for node-website
    if (options && options.store) {
      options.store.watch(
        () => options.store.state.userinfo,
        val => {
          if (val.id) {
            stat.identify(val.id, val)
          }
        }
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/frontend-lib/mixins/statPlugin.js